import React from 'react';
import s from './AvatarComponent.module.css';
const AvatarComponent = ({
    avatarUrl,
    userName,
    width,
    height,
}: {
    avatarUrl: string;
    userName: string;
    width?: number;
    height?: number;
}) => {
    const fontSize = width && height ? `${Math.floor(Math.min(width, height) / 2)}px` : '14px';

    return (
        <div className={s.container}>
            {avatarUrl ? (
                <img src={avatarUrl} alt="avatar" className={s.avatar} style={{ width, height }} />
            ) : (
                <div className={s.avatar} style={{ width, height, fontSize }}>
                    {userName.charAt(0).toUpperCase()}
                </div>
            )}
        </div>
    );
};

export default AvatarComponent;
